// Open IndexedDB database
const openDB = async ({DBName = "", storeName = ""}) => {
    if ("" === DBName || "" === storeName) return;

    return new Promise((resolve, reject) => {

        const request = window.indexedDB.open(DBName);

        request.onerror = () => {
            Mutil.setLocalJson(DBName, "")
            reject('Error opening database');
        };

        request.onsuccess = () => {
            resolve(request.result);
        };

        // 데이터베이스 업그레이드 및 마이그레이션
        request.onupgradeneeded = (event) => {
            const db = request.result;

            // 이전 버전의 객체 스토어가 있는 경우 삭제
            if (event.oldVersion > 0 && event.oldVersion < db.version) {
                db.deleteObjectStore(storeName);
            }

            // 새로운 버전의 객체 스토어 생성
            const objectStore = db.createObjectStore(storeName, {keyPath: 'index'});
            objectStore.createIndex('index', 'value', {unique: true});

            // 기존 데이터 마이그레이션
            if (event.oldVersion > 0) {
                const transaction = event.target.transaction;
                const oldStore = transaction.objectStore(storeName);

                oldStore.openCursor().onsuccess = function (event) {
                    const cursor = event.target.result;
                    if (cursor) {
                        // 새로운 버전의 객체 스토어에 데이터 추가
                        const newStore = event.target.result.objectStore(storeName);
                        newStore.add(cursor.value);
                        cursor.continue();
                    }
                };

                // 기존 객체 스토어 삭제
                oldStore.clear();
            }
        };
    });
};

const deleteDatabase = (DBName) => {
    if(!checkSupport()) return;

    // 데이터베이스 삭제
    const deleteRequest = window.indexedDB.deleteDatabase(DBName);

    deleteRequest.onerror = function (event) {
        // 데이터베이스 삭제 중 오류 발생 시 처리
        console.log("Database deletion error:", event.target.errorCode);
    };

    deleteRequest.onsuccess = function (event) {
        // 데이터베이스 삭제 성공 시 처리
        Mutil.setLocalJson(DBName, {})
        // console.log("Database deleted successfully.");
    };
}

//read bound target record
const readTargetRecord = async () => {
    if(!checkSupport()) return;

    return await readRecords({
        DBName: 'WidgetDB',
        storeName: this.$props.WIDGET_USER_SRNO,
        key: this.$props.keySrno
    });
}

const checkSupport = () => {
    if(!window.indexedDB){
        console.log('[indexedDB] 지원하지 않는 브라우저')
        return false;
    } else {
        return true
    }
}

// Read records
const readRecords = async ({DBName, storeName}) => {
    if(!checkSupport()) return;

    const db = await openDB({DBName, storeName});
    const transaction = db.transaction([storeName], 'readonly');
    const objectStore = transaction.objectStore(storeName);
    const request = objectStore.getAll();


    return new Promise((resolve, reject) => {
        request.onsuccess = async () => {
            resolve(request.result);
        };

        request.onerror = () => {
            Mutil.setLocalJson(DBName, {})
            reject('Error reading records');
        };

        // 트랜잭션 완료 및 데이터베이스 연결 종료
        transaction.oncomplete = function () {
            db.close();
        };
    });
};

// Create a new record
const createRecord = async ({DBName, storeName, record, key, pageData}) => {
    if(!checkSupport()) return;

    const db = await openDB({DBName, storeName});
    const transaction = db.transaction([storeName], 'readwrite');
    const objectStore = transaction.objectStore(storeName);

    let index = 0;
    if (record.length > 0) {
        return addNextData(); // 리스트 순차적으로 저장
    } else {
        await objectStore.put({
                ...record,
                srno: record[key],
                index: index + (pageData.PG_NO - 1) * pageData.PG_PER_CNT
            }
        );

        return new Promise((resolve, reject) => {
            transaction.oncomplete = () => {
                db.close(); //이벤트가 트리거될 때 데이터베이스 연결을 반드시 닫아야 블락되지 않는다.
                resolve('Record created successfully');
            };

            transaction.onerror = () => {
                reject('Error creating record');
            };
        });
    }


    function addNextData() {
        if (index < record.length) {
            const v = record[index];
            const addRequest = objectStore.put({
                ...v,
                id: v[key],
                index: index + (pageData.PG_NO - 1) * pageData.PG_PER_CNT
            });

            addRequest.onsuccess = async function () {
                index++;
                await addNextData(); // 다음 데이터 추가 호출
            };

            addRequest.onerror = function (event) {
                console.error(`Failed to add Data ${index + 1}:`, event.target.error);
            };
        } else {
            return new Promise((resolve, reject) => {
                transaction.oncomplete = () => {
                    db.close(); //이벤트가 트리거될 때 데이터베이스 연결을 반드시 닫아야 블락되지 않는다.
                    resolve('Record created successfully');
                };

                transaction.onerror = () => {
                    reject('Error creating record');
                };
            });
        }
    }

};

const deleteStore = async ({DBName, storeName}) => {
    if(!checkSupport()) return;

    const db = await openDB({DBName, storeName});

    // 트랜잭션 시작
    const transaction = db.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);

    // 스토어 삭제
    const deleteRequest = objectStore.clear();

    deleteRequest.onsuccess = function () {
        // console.log("Object store deleted successfully.");
    };

    deleteRequest.onerror = function (event) {
        Mutil.setLocalJson(DBName, {})
        console.error("Failed to delete object store:", event.target.error);
    };

    // 트랜잭션 완료 및 데이터베이스 연결 종료
    transaction.oncomplete = function () {
        db.close();
    };
}

// Update a record
const updateRecord = async ({DBName, storeName, id, newData}) => {
    if(!checkSupport()) return;

    const db = await openDB({DBName, storeName});
    const transaction = db.transaction([storeName], 'readwrite');
    const objectStore = transaction.objectStore(storeName);
    const request = objectStore.get(id);

    request.onsuccess = () => {
        const record = request.result;

        if (record) {
            Object.assign(record, newData);
            objectStore.put(record);
        }
    };

    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve('Record updated successfully');
            db.close();
        };

        transaction.onerror = () => {
            Mutil.setLocalJson(DBName, {})
            reject('Error updating record');
        };
    });
};

// Delete a record
const deleteRecord = async ({DBName, storeName, id}) => {
    if(!checkSupport()) return;

    const db = await openDB({DBName, storeName});
    const transaction = db.transaction([storeName], 'readwrite');
    const objectStore = transaction.objectStore(storeName);
    objectStore.delete(id);

    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve('Record deleted successfully');
            db.close();
        };

        transaction.onerror = () => {
            Mutil.setLocalJson(DBName, {})
            reject('Error deleting record');
        };
    });
};

export {
    createRecord,
    readTargetRecord,
    readRecords,
    updateRecord,
    deleteRecord,
    deleteStore,
    deleteDatabase,
}
